
import { TimeSlot, DayOfWeek } from '@/models/Schedule';
import { useTimeSlotFormInitialization } from './hooks/useTimeSlotFormInitialization';
import { useTimeSlotSubmission } from './hooks/useTimeSlotSubmission';

interface UseTimeSlotCreateFormProps {
  existingTimeSlots: TimeSlot[];
  preselectedDay?: DayOfWeek;
  open: boolean;
  onCreateTimeSlots: (timeSlots: any[]) => Promise<void>;
  onOpenChange: (open: boolean) => void;
}

export const useTimeSlotCreateForm = ({
  existingTimeSlots,
  preselectedDay,
  open,
  onCreateTimeSlots,
  onOpenChange,
}: UseTimeSlotCreateFormProps) => {
  const { form, isRecurringMode } = useTimeSlotFormInitialization({
    preselectedDay,
    open,
  });

  const { isSubmitting, onSubmit } = useTimeSlotSubmission({
    existingTimeSlots,
    onCreateTimeSlots,
    onOpenChange,
  });

  return {
    form,
    isSubmitting,
    isRecurringMode,
    onSubmit,
  };
};
